<template>
    <CardView title="Satellite Missions" ttyId="10" :filterControls="filterControls"></CardView>
</template>

<script>
    import CardView from '@/components/CardView.vue'
    export default {
        name: 'SatelliteMissionsCards',
        components: {
            CardView
        },
        data() {
            return {
                filterControls:[] // [{ matId: 876 }, { matId: 877 }]
            }
        },
    }
</script>
<style scoped>
</style>
